import axios from "axios";

interface Args {
  url: string;
  headers: any;
  signal: AbortSignal;
  filename?: string;
}
export const downloadFile = async ({
  url,
  headers,
  signal,
  filename = "download"
}: Args): Promise<void> => {
  const res = await axios.get(url, {
    responseType: "blob",
    headers,
    signal
  });

  const objectUrl = window.URL.createObjectURL(res.data);
  const anchor = document.createElement("a");
  document.body.appendChild(anchor);
  anchor.href = objectUrl;
  anchor.download = filename;
  anchor.click();
  window.URL.revokeObjectURL(objectUrl);
};
